/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Chart_StackedInputs */

const en_admin_ai_chat_chart_stacked = /** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stacked`)
};

const de_admin_ai_chat_chart_stacked = /** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestapelt`)
};

const es_admin_ai_chat_chart_stacked = /** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apilado`)
};

const fr_admin_ai_chat_chart_stacked = /** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empilé`)
};

const nl_admin_ai_chat_chart_stacked = /** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestapeld`)
};

/** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */
const it_admin_ai_chat_chart_stacked = en_admin_ai_chat_chart_stacked;

/** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_chart_stacked = en_admin_ai_chat_chart_stacked;

/** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */
const pl_admin_ai_chat_chart_stacked = en_admin_ai_chat_chart_stacked;

/** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */
const hu_admin_ai_chat_chart_stacked = en_admin_ai_chat_chart_stacked;

/** @type {(inputs: Admin_Ai_Chat_Chart_StackedInputs) => LocalizedString} */
const ro_admin_ai_chat_chart_stacked = en_admin_ai_chat_chart_stacked;

/**
* | output |
* | --- |
* | "Stacked" |
*
* @param {Admin_Ai_Chat_Chart_StackedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_chart_stacked = /** @type {((inputs?: Admin_Ai_Chat_Chart_StackedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Chart_StackedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_chart_stacked(inputs)
	if (locale === "de") return de_admin_ai_chat_chart_stacked(inputs)
	if (locale === "es") return es_admin_ai_chat_chart_stacked(inputs)
	if (locale === "fr") return fr_admin_ai_chat_chart_stacked(inputs)
	if (locale === "nl") return nl_admin_ai_chat_chart_stacked(inputs)
	if (locale === "it") return it_admin_ai_chat_chart_stacked(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_chart_stacked(inputs)
	if (locale === "pl") return pl_admin_ai_chat_chart_stacked(inputs)
	if (locale === "hu") return hu_admin_ai_chat_chart_stacked(inputs)
	return ro_admin_ai_chat_chart_stacked(inputs)
});
export { admin_ai_chat_chart_stacked as "admin.ai_chat.chart_stacked" }